import { useState } from "react"
import Button, {
  type ButtonProps,
} from "@/v2-backoffice-client/components/button"
import LicenseCreateDialog from "@/v2-backoffice-client/license/create/LicenseCreateDialog"

export type LicenseCreateButtonProps = ButtonProps & {
  customerId?: number
  customerName?: string
}

function LicenseCreateButton(props: LicenseCreateButtonProps) {
  const { customerId, customerName, onClick, children, ...buttonProps } = props
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <Button
        variant="primary"
        size="tiny"
        iconSrc="plus"
        iconSize={10}
        data-feature-code="UI_BackofficeLicense_Board_Create"
        onClick={(e) => {
          setIsOpen(true)
          onClick?.(e)
        }}
        {...buttonProps}
      >
        {children ?? "Grant license"}
      </Button>

      <LicenseCreateDialog
        customerId={customerId}
        customerName={customerName}
        open={isOpen}
        onOpenChange={setIsOpen}
      />
    </>
  )
}

export default LicenseCreateButton
